import { MealPreferences } from 'fitbeat.models';
import moment from 'moment-timezone';
import {
  CHANGE_NUTRITION_DAY,
  CLEAR_MEALS_FOR_TIME_OF_DAY,
  GET_MEAL_PLAN_FAILED,
  GET_MEAL_PLAN_REQUEST,
  GET_MEAL_PLAN_SUCCESS,
  GET_MEALS_FOR_TIME_OF_DAY_FAILED,
  GET_MEALS_FOR_TIME_OF_DAY_REQUEST,
  GET_MEALS_FOR_TIME_OF_DAY_SUCCESS,
  GET_NUTRITION_RATING_DATA,
  GET_NUTRITION_RATING_DATA_FAILED,
  GET_SHOPPING_LIST_FAILED,
  GET_SHOPPING_LIST_REQUEST,
  GET_SHOPPING_LIST_SUCCESS,
  GET_THUMBNAILS_REQUEST,
  MAXIMUM_MEAL_PREP_TIME_CHANGED,
  MEAL_ROW_PRESSED,
  SAVE_DIET_GOAL_FAILED,
  SAVE_DIET_GOAL_REQUEST,
  SAVE_DIET_GOAL_SUCCESS,
  SAVE_FOOD_PREFERENCES_FAILED,
  SAVE_FOOD_PREFERENCES_REQUEST,
  SAVE_FOOD_PREFERENCES_SUCCESS,
  SET_CHECKLIST_EXCLUSIONS_FAILED,
  SET_IMAGE,
  SET_NUTRITION_PREFERENCE,
  SET_NUTRITION_RATING_FAILED,
  SET_NUTRITION_RATING_REQUEST,
  SET_NUTRITION_RATING_SUCCESS,
  SET_SHOPPING_LIST_SETTINGS_FAILED,
  SET_SHOPPING_LIST_SETTINGS_REQUEST,
  SET_TAB_INDEX,
  SET_THUMBNAILS,
  SET_UNIT_PREFERENCE,
  SET_USER_MEAL_PLAN_FAILED,
  SET_USER_MEAL_PLAN_REQUEST,
  SET_USER_MEAL_PLAN_SUCCESS,
  TOGGLE_MEAL_MODAL,
  TOGGLE_MEAL_SELECTION_WIZARD_SCREEN,
  TOGGLE_NUTRITION_REVIEW_BODY,
} from './actionTypes';

export interface INutritionState {
  isLoading: boolean;
  error: null | Error;
  mealPlans: any;
  shoppingList: any;
  thumbnails: any;
  mealsForTimeOfDay: any;
  images: any;
  nutritionPreference: undefined | MealPreferences;
  isLoadingMealsForTimeOfDay: boolean;
  tabIndex: number;
  isUserNutritionReviewVisible: boolean;
  isNutritionReviewBodyVisible: boolean;
  latestNutritionRating: null | number;
  nutritionStarRating: number;
  mealOpenInModal: any;
  mealOfDayOpenInModal: string;
  viewingMealsForDay: Date;
  mealChanged: boolean;
  showMealSelectionOverView: boolean;
  maximumMealPrepTime: null | number;
  mealPlanChangeLoading: boolean;
}

const initialState: INutritionState = {
  isLoading: false,
  error: null,
  mealPlans: null,
  shoppingList: null,
  thumbnails: {},
  mealsForTimeOfDay: {},
  images: {},
  nutritionPreference: undefined,
  isLoadingMealsForTimeOfDay: false,
  tabIndex: 0,
  isUserNutritionReviewVisible: false,
  isNutritionReviewBodyVisible: true,
  latestNutritionRating: null,
  nutritionStarRating: 0,
  mealOpenInModal: {},
  mealOfDayOpenInModal: '',
  viewingMealsForDay: moment(),
  mealChanged: false,
  showMealSelectionOverView: true,
  maximumMealPrepTime: null,
  mealPlanChangeLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MEAL_ROW_PRESSED: {
      return {
        ...state,
        mealOpenInModal: action.payload.mealOpenInModal,
        mealOfDayOpenInModal: action.payload.mealOfDayOpenInModal,
        mealChanged: false,
        viewingMealsForDay: action.payload.mealOpenInModal.date || state.viewingMealsForDay,
      };
    }
    case TOGGLE_MEAL_MODAL: {
      const modalWillClose = !action.visible;
      if (modalWillClose) {
        return {
          ...state,
          mealOpenInModal: {},
          mealOfDayOpenInModal: '',
        };
      }
      return { ...state };
    }
    case CHANGE_NUTRITION_DAY: {
      return {
        ...state,
        viewingMealsForDay: action.payload.newDay,
      };
    }
    case CLEAR_MEALS_FOR_TIME_OF_DAY: {
      return {
        ...state,
        mealsForTimeOfDay: {},
      };
    }
    case SET_NUTRITION_PREFERENCE: {
      return {
        ...state,
        nutritionPreference: action.payload,
        mealPlans: null,
        shoppingList: null,
      };
    }
    case SET_UNIT_PREFERENCE: {
      return {
        ...state,
        mealPlans: null,
        shoppingList: null,
      };
    }
    case SET_SHOPPING_LIST_SETTINGS_FAILED: {
      return {
        ...state,
        error: action.payload,
        shoppingList: null,
        mealPlan: null,
      };
    }
    case SET_SHOPPING_LIST_SETTINGS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
        mealPlans: null,
        shoppingList: null,
      };
    }
    case SET_USER_MEAL_PLAN_REQUEST: {
      return {
        ...state,
        error: null,
        mealOpenInModal: action.payload.newMeal,
        mealChanged: true,
        mealPlanChangeLoading: true,
      };
    }
    case SET_USER_MEAL_PLAN_SUCCESS: {
      return {
        ...state,
        error: null,
        mealPlans: action.payload.mealplan,
        shoppingList: action.payload.shoppingList,
        mealPlanChangeLoading: false,
      };
    }
    case SET_USER_MEAL_PLAN_FAILED: {
      return {
        ...state,
        error: action.payload,
        mealPlans: null,
        shoppingList: null,
        mealPlanChangeLoading: false,
      };
    }
    case GET_MEALS_FOR_TIME_OF_DAY_SUCCESS: {
      const meals = { ...state.mealsForTimeOfDay };
      meals[action.payload.mealOfDay] = [...action.payload.meals];
      return {
        ...state,
        mealsForTimeOfDay: meals,
        isLoadingMealsForTimeOfDay: false,
        error: null,
      };
    }
    case GET_MEALS_FOR_TIME_OF_DAY_REQUEST: {
      const meals = { ...state.mealsForTimeOfDay };
      meals[action.payload.mealOfDay] = undefined;
      return {
        ...state,
        isLoadingMealsForTimeOfDay: true,
        error: null,
        mealsForTimeOfDay: meals,
      };
    }
    case GET_MEALS_FOR_TIME_OF_DAY_FAILED: {
      const meals = { ...state.mealsForTimeOfDay };
      meals[action.payload.mealOfDay] = undefined;
      return {
        ...state,
        isLoadingMealsForTimeOfDay: false,
        error: action.payload.error,
        mealsForTimeOfDay: meals,
      };
    }
    case SAVE_FOOD_PREFERENCES_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SAVE_FOOD_PREFERENCES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case SAVE_FOOD_PREFERENCES_FAILED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case SAVE_DIET_GOAL_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SAVE_DIET_GOAL_SUCCESS: {
      return {
        ...state,
      };
    }
    case SAVE_DIET_GOAL_FAILED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case GET_MEAL_PLAN_REQUEST: {
      return {
        ...state,
        isLoading: !state.mealPlans,
        error: null,
      };
    }
    case GET_MEAL_PLAN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        mealPlans: action.payload.mealPlan,
        shoppingList: action.payload.shoppingList,
      };
    }
    case GET_MEAL_PLAN_FAILED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case GET_SHOPPING_LIST_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
        shoppingList: null,
      };
    }
    case GET_SHOPPING_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        shoppingList: action.payload,
      };
    }
    case GET_SHOPPING_LIST_FAILED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        shoppingList: null,
      };
    }
    case SET_CHECKLIST_EXCLUSIONS_FAILED: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        shoppingList: null,
      };
    }
    case SET_THUMBNAILS: {
      return {
        ...state,
        thumbnails: action.payload.thumbnails,
      };
    }
    case SET_IMAGE: {
      return {
        ...state,
        images: {
          ...state.images,
          [action.payload.mealId]: action.payload.image,
        },
      };
    }
    case GET_THUMBNAILS_REQUEST: {
      return {
        ...state,
      };
    }
    case SET_TAB_INDEX: {
      return {
        ...state,
        tabIndex: action.payload,
      };
    }
    case SET_NUTRITION_RATING_REQUEST: {
      return {
        ...state,
        nutritionStarRating: action.payload.nutritionStarRating,
        error: null,
      };
    }
    case SET_NUTRITION_RATING_SUCCESS: {
      return {
        ...state,
        isUserNutritionReviewVisible: false,
        nutritionStarRating: 0,
        error: null,
      };
    }
    case SET_NUTRITION_RATING_FAILED: {
      return {
        ...state,
      };
    }
    case GET_NUTRITION_RATING_DATA_FAILED: {
      return {
        ...state,
      };
    }
    case GET_NUTRITION_RATING_DATA: {
      let shouldShowNutritionRating = false;
      const ratings = action.payload.userProfile.nutritionRatings;
      if (ratings.length > 0) {
        const latestRating = (ratings.sort((a, b) => new Date(b).getTime() - new Date(a).getTime()))[0];
        if (moment(latestRating.date).isBefore(moment().subtract(7, 'd'))) {
          shouldShowNutritionRating = true;
        }
      }
      let lastReview;
      if (action.payload.latestRating.date) {
        const today = moment().startOf('day');
        const latestReviewDate = moment(action.payload.latestRating.date).startOf('day');
        const diffDays = today.diff(latestReviewDate, 'days');
        const textToDisplay = diffDays === 1 ? ' day ago' : ' days ago';
        lastReview = diffDays === 0 ? undefined : diffDays + textToDisplay;
      }
      return {
        ...state,
        isUserNutritionReviewVisible: shouldShowNutritionRating,
        latestNutritionRating: lastReview,
      };
    }
    case TOGGLE_NUTRITION_REVIEW_BODY: {
      return {
        ...state,
        isNutritionReviewBodyVisible: !state.isNutritionReviewBodyVisible,
      };
    }
    case TOGGLE_MEAL_SELECTION_WIZARD_SCREEN : {
      return {
        ...state,
        showMealSelectionOverView: !state.showMealSelectionOverView,
      };
    }
    case MAXIMUM_MEAL_PREP_TIME_CHANGED : {
      return {
        ...state,
        maximumMealPrepTime: action.payload.maximumMealPrepTime,
      };
    }
    default:
      return state;
  }
};
